import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import { bgGradient } from 'src/theme/css';
import ZekiWarning from 'src/assets/illustrations/zeki-warning';

import { ConfirmDialogProps } from './types';

// ----------------------------------------------------------------------

export default function ConfirmDialog({
  title,
  content,
  action,
  open,
  onClose,
  showZekiIllustration = false,

  ...other
}: ConfirmDialogProps) {
  const theme = useTheme();

  const renderIllustration = (
    <Stack
      flexGrow={1}
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4,
        ...bgGradient({
          startColor: theme.palette.secondary.main,
          endColor: theme.palette.primary.main,
          direction: '311.67deg',
        }),
      }}
    >
      <ZekiWarning />
    </Stack>
  );

  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose} {...other}>
      {showZekiIllustration && renderIllustration}

      <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>

      {content && <DialogContent sx={{ typography: 'body2' }}> {content} </DialogContent>}

      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={onClose}>
          Voltar
        </Button>
        {action}
      </DialogActions>
    </Dialog>
  );
}
